// Action Types
export const CART_ADD_ITEM = 'cart/addItem';
export const CART_REMOVE_ITEM = 'cart/removeItem';
export const CART_DECREASE_ITEM = 'cart/decreaseItem';


export const clearCart = () => ({
  type: 'CLEAR_CART',
});

export function addCartItem(productData) {
  return { type: CART_ADD_ITEM, payload: productData }
}

export function removeCartItem(productId) {
  return { type: CART_REMOVE_ITEM, payload: productId };
}

export function decreaseCartItem(productId) {
  return { type: CART_DECREASE_ITEM, payload: productId };
}

export default function cartReducer(state = [], action) {
  switch (action.type) {
    case CART_ADD_ITEM:
      const existingItem = state.find(
        (cartItem) => cartItem.productId === action.payload.productId
      )

      
      if (existingItem) {
        return state.map((cartItem) => {
          if (cartItem.productId === existingItem.productId) {
            return { ...cartItem, quantity: cartItem.quantity + 1 }
          }
          return cartItem
        })
      }
      return [...state, { ...action.payload, quantity: 1 }]

    case CART_REMOVE_ITEM:
      return state.filter(cartItem => cartItem.productId !== action.payload);
    case CART_DECREASE_ITEM:
      return state.map((cartItem) => {
        if (cartItem.productId === action.payload) {
          if (cartItem.quantity > 1) {
            return { ...cartItem, quantity: cartItem.quantity - 1 };  
          }
          return cartItem;  
        }
        return cartItem;
      });
      case 'CLEAR_CART':
            return []; 
    default:
      return state
  }
}